import {
  SectionElement,
  defineElement,
  onClick,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-accordion-slider/common-accordion-slider.ts
var CommonAccordionSlider = class extends SectionElement {
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    if (this.accordions[index].isOpen) {
      this.close(index);
    } else {
      this.closeAll();
      this.open(index);
    }
  }
  open(index) {
    this.accordions[index].open();
    this.chevrons[index].classList.add("rotate-180");
    this.images[index].classList.remove("opacity-0");
    this.imageShadows[index].classList.remove("opacity-0");
  }
  close(index) {
    this.accordions[index].close();
    this.chevrons[index].classList.remove("rotate-180");
  }
  closeAll() {
    this.accordions.forEach((accordion, index) => {
      this.close(index);
    });
    this.images.forEach((image) => {
      image.classList.add("opacity-0");
    });
    this.imageShadows.forEach((imageShadow) => {
      imageShadow.classList.add("opacity-0");
    });
  }
  /*
  async connectedCallback () {
    this.open(0)
  }
  */
};
__decorateClass([
  queryAll("[data-accordion]")
], CommonAccordionSlider.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-image]")
], CommonAccordionSlider.prototype, "images", 2);
__decorateClass([
  queryAll("[data-chevron]")
], CommonAccordionSlider.prototype, "chevrons", 2);
__decorateClass([
  queryAll("[data-image-shadow]")
], CommonAccordionSlider.prototype, "imageShadows", 2);
__decorateClass([
  onClick("[data-open-button]")
], CommonAccordionSlider.prototype, "handleOpenButtonClick", 1);
CommonAccordionSlider = __decorateClass([
  defineElement("common-accordion-slider")
], CommonAccordionSlider);
export {
  CommonAccordionSlider
};
